import { render, staticRenderFns } from "./social-overview.vue?vue&type=template&id=659e2856&scoped=true"
import script from "./social-overview.vue?vue&type=script&lang=js"
export * from "./social-overview.vue?vue&type=script&lang=js"
import style0 from "./social-overview.vue?vue&type=style&index=0&id=659e2856&prod&lang=scss"
import style1 from "./social-overview.vue?vue&type=style&index=1&id=659e2856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659e2856",
  null
  
)

export default component.exports